import { SVG, SVGProps } from './svg'

export function IconWarning(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M23 19.6L12.7 2.4a.8.8 0 00-.6-.4h-.3c-.3 0-.6.1-.7.4L1.1 19.6c-.1.3-.1.6 0 .8l.1.2c.2.3.4.4.7.4H22c.3 0 .5-.1.7-.4l.1-.2c.1-.2.1-.5 0-.8zm-10-3.1c0 .3-.2.5-.5.5h-1a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v1zm-.5-3.5c.2 0 .3 0 .3-.2l.4-3.2a.5.5 0 00-.5-.6h-1.4a.5.5 0 00-.5.6l.4 3.2c0 .1.1.2.3.2h1z"
      />
    </SVG>
  )
}
